// Convierte "Título Con Mayúsculas" → "Título con mayúsculas" (solo la primera letra en mayúscula).
export const sentenceCase = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1).toLowerCase() : s);
